"use client";
import useInteractionStart from "@/hooks/useInteractionStart";
import React, { PropsWithChildren, useState } from "react";
import { useInViewEffect } from "react-hook-inview";

const ElementWapper: React.FC<PropsWithChildren> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { isInteracting } = useInteractionStart();
  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
      setIsVisible(entry.isIntersecting);
    },
    { threshold: 0 },
  );
  return (
    <div ref={ref}>
      {isVisible || isInteracting ? (
        children
      ) : (
        <div
          className={`skeleton-rect`}
          style={{
            width: "100%",
            paddingTop: `${377}px`,
          }}
        />
      )}
    </div>
  );
};

export default ElementWapper;
